// Standard components - načítají se vždy
import TempusDominusComponent from "../TempusDominus";
import ResponsiveButton from "../ResponsiveButton";
import AreYouSureModal from "../AreYouSureModal";
import AfterAjax from "../AfterAjax";
import Select2 from '../Select2';
import Select from '../Select';
import BulkChecker from '../BulkChecker';
import FulltextSearcher from '../FulltextSearcher';
import AplCodeGenerator from '../AplCodeGenerator';
import Toastr from '../toastr';
import DatatableInitter from '../DataTable/Components/DatatableInitter';
import BulkDataTableChecker from '../DataTable/Components/BulkChecker'
import BulkDataTableAction from '../DataTable/Components/BulkAction'
import TopMenu from '../TopMenu';
import { dom } from '../../fontawesome-core-wrapper';

// Konfigurační soubor - definuje lazy a external komponenty
import bundleConfig from '../../bundle.config.js';

export default class ComponentLoader {
	constructor() {
		// init() je async, ale voláme ho bez await - eventy se pošlou později
		this.init().catch(error => {
			console.error('Failed to initialize components:', error);
		});
		document.dispatchEvent(new Event("afterInitMetronicComponents"));

		AfterAjax.addInitOnAjaxFunction(async () => {
			await this.init();
			this.initAfterAjax();
		});
	}

	async init() {
		// External bundles - jen inicializace (kód už je v samostatném bundle)
		// Metronic - kód je v metronic.bundle.js, jen inicializujeme wrapper
		if (bundleConfig.externalBundles.Metronic && typeof window.KTApp !== 'undefined') {
			try {
				const Metronic = (await import('../Metronic')).default;
				new Metronic();
			} catch (error) {
				console.warn('Failed to initialize Metronic wrapper:', error);
			}
		}

		// Standard components - načítají se vždy
		new TempusDominusComponent();
		new ResponsiveButton();
		new AreYouSureModal();
		new BulkChecker();
		new Select2();
		new Select();
		new FulltextSearcher();
		new AplCodeGenerator();
		new Toastr();
		new DatatableInitter();
		new BulkDataTableChecker();
		new BulkDataTableAction();
		new TopMenu();

		// External bundles - DataTable (kód už je v datatables.bundle.js)
		if (bundleConfig.externalBundles.DataTable && typeof window.$ !== 'undefined' && typeof window.$.fn.dataTable !== 'undefined') {
			try {
				const DataTable = (await import('../DataTable')).default;
				new DataTable();
			} catch (error) {
				console.warn('Failed to initialize DataTable wrapper:', error);
			}
		}

		// Lazy loaded components - načítají se až když jsou potřeba
		await this.initLazyComponents();

		document.dispatchEvent(new Event("afterInitComponents"));
	}

	async initLazyComponents() {
		// TinyMCE lazy loading
		if (bundleConfig.lazyLoad.TinyMce && bundleConfig.lazyLoad.TinyMce.check && bundleConfig.lazyLoad.TinyMce.check()) {
			try {
				// Dynamický import - vytvoří samostatný chunk
				const TinyMceModule = await import('../TinyMce');
				const TinyMceClass = TinyMceModule.default;
				new TinyMceClass();
			} catch (error) {
				console.warn('Failed to lazy load TinyMce:', error);
			}
		}

		// Další lazy komponenty můžeme přidat zde
		// for (const [componentName, config] of Object.entries(bundleConfig.lazyLoad || {})) {
		// 	if (componentName === 'TinyMce') continue; // už zpracováno výše
		// 	// ...
		// }
	}

	initAfterAjax() {
		KTMenu.init();
		KTDrawer.init();
		KTUtil.init();
		KTApp.init();

		// Convert FontAwesome icons after AJAX updates
		if (typeof dom !== "undefined" && dom.i2svg) {
			dom.i2svg();
		}

		// Lazy load components after AJAX (např. nový TinyMCE textarea)
		this.initLazyComponents().catch(error => {
			console.warn('Failed to lazy load components after AJAX:', error);
		});

		const activities = document.querySelector("#kt_activities");

		if (activities) {
			KTDrawer.getInstance(activities).on("kt.drawer.hide", function () {
				const overlay = document.querySelector('.drawer-overlay');

				if (overlay) {
					document.querySelector('.drawer-overlay').remove();
				}
			});
		}

		document.dispatchEvent(new Event("afterInitMetronicComponents"));
	}
}
